export default function EditChangeLogAttributesDialogController(
  $scope,
  $rootScope,
  alerts,
  loaderService,
  ssDialogService,
  pmDataService,
) {
  const vm = this;
  vm.handleClose = _handleClose;
  vm.handleSubmit = _handleSubmit;
  vm.isMaterialChange = 'no';
  vm.explanation = null;

  _activate();
  _initEventListeners();

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSubmit() {
    if ($scope.editChangeLogAttributesForm.$valid) {
      if (vm.isMaterialChange === 'yes') {
        vm._isMaterialChange = true;
      } else {
        vm._isMaterialChange = false;
      }
      const documentChangeLogAudit = {
        documentChangeLogAuditId: 0,
        documentChangeLogId: vm.changeLogItem.documentChangeLogId,
        isMaterialChangeFrom: vm.changeLogItem.isMaterialChange,
        isMaterialChangeTo: vm._isMaterialChange,
        explanationFrom: vm.changeLogItem.explanation,
        explanationTo: vm.explanation,
      };

      loaderService.showViewLoader = true;
      return pmDataService.saveDocumentChangeLogAudit(documentChangeLogAudit).then((response) => {
        $rootScope.$broadcast('refreshDocumentChangeLogAudits', {
          documentChangeLogId: vm.changeLogItem.documentChangeLogId,
          documentChangeLogAudit: response.data,
        });
        alerts.success('Change successfully edited.');
        _closeDialog();
      });
    }
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    if (vm.changeLogItem.isMaterialChange) {
      vm.isMaterialChange = 'yes';
    } else {
      vm.isMaterialChange = 'no';
    }

    vm.explanation = vm.changeLogItem.explanation;
  }

  function _initEventListeners() {
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.materialChangeDialog);
  }
}

EditChangeLogAttributesDialogController.$inject = [
  '$scope',
  '$rootScope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'pmDataService',
];
